import { SwitchInputField, TextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, isDirty, reset } from "redux-form"

const SettingsTab = ({ handleSave, tabIsActive, resetForm, isDirty }) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Card className="mt-3">
        <CardHeader>
          <h4>ADDITIONAL DETAILS</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-3" style={{ minWidth: "191px" }}>
              <label>Published</label>
            </Col>
            <Col>
              <Field
                name="status"
                component={SwitchInputField}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor="#2ECC71"
                offColor="#E74C3C"
                height={20}
                width={40}
                handleDiameter={18}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs="auto" className="mt-2">
              <label>Limit display time (hours)</label>
            </Col>
            <Col>
              <Field
                name="visibility_limit"
                component={TextField}
                type="number"
                min="0"
              />
              <span>Zero for no limit; display each time</span>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs="auto" className="mt-3" style={{ minWidth: "191px" }}>
              <label>This is an advertisement</label>
            </Col>
            <Col>
              <Field
                name="is_advertisement"
                component={SwitchInputField}
                uncheckedIcon={false}
                checkedIcon={false}
                onColor="#2ECC71"
                offColor="#E74C3C"
                height={20}
                width={40}
                handleDiameter={18}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.POPUP)(
    state,
    ...["is_advertisement", "status", "visibility_limit"]
  ),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.POPUP)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsTab)
